<!-- ============================================================================
     CustomerFormTypeObjectComponent template

     Complex Configuration Entity page for a single CustomerFormType.
     Each navigation item renders the children of this Formulartyp that belong
     to the same module (Felder, Sub-Formulare, Interaktionstypen, Onboarding-Typen).

     Pattern reference: DmDocumentTypeObjectComponent.
     ============================================================================ -->

@if (initialized && dto) {

    @if (activeNavigationItems?.action === 'fields') {
        <div class="p-3">
            @if (fieldsWidget) {
                <mvs-widget [widgetData]="fieldsWidget"></mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItems?.action === 'subForms') {
        <div class="p-3">
            @if (subFormTypesWidget) {
                <mvs-widget [widgetData]="subFormTypesWidget"></mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItems?.action === 'interactionTypes') {
        <div class="p-3">
            @if (interactionTypesWidget) {
                <mvs-widget [widgetData]="interactionTypesWidget"></mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItems?.action === 'onboardingTypes') {
        <div class="p-3">
            @if (onboardingTypesWidget) {
                <mvs-widget [widgetData]="onboardingTypesWidget"></mvs-widget>
            }
        </div>
    }
}
